/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PageWidgetKeyResponseDTO } from '../models';
// @ts-ignore
import type { WidgetKeyCreateDTO } from '../models';
// @ts-ignore
import type { WidgetKeyResponseDTO } from '../models';
// @ts-ignore
import type { WidgetKeyUpdateDTO } from '../models';
/**
 * WidgetKeysApi - axios parameter creator
 * @export
 */
export const WidgetKeysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a widget key for an agent in the current organization.  The returned ``key`` is a PUBLIC identifier shipped in client-side JS; it can be re-read at any time. An empty ``allowed_origins`` is accepted but leaves the key inert from every origin until origins are configured.  Requires \'widget_key:write\' permission.
         * @summary Create Widget Key
         * @param {WidgetKeyCreateDTO} widgetKeyCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWidgetKeyApiV1WidgetKeysPost: async (widgetKeyCreateDTO: WidgetKeyCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'widgetKeyCreateDTO' is not null or undefined
            assertParamExists('createWidgetKeyApiV1WidgetKeysPost', 'widgetKeyCreateDTO', widgetKeyCreateDTO)
            const localVarPath = `/api/v1/widget-keys/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(widgetKeyCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a widget key for an agent in the current organization.  The returned ``key`` is a PUBLIC identifier shipped in client-side JS; it can be re-read at any time. An empty ``allowed_origins`` is accepted but leaves the key inert from every origin until origins are configured.  Requires \'widget_key:write\' permission.
         * @summary Create Widget Key
         * @param {WidgetKeyCreateDTO} widgetKeyCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWidgetKeyApiV1WidgetKeysPost_1: async (widgetKeyCreateDTO: WidgetKeyCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'widgetKeyCreateDTO' is not null or undefined
            assertParamExists('createWidgetKeyApiV1WidgetKeysPost_1', 'widgetKeyCreateDTO', widgetKeyCreateDTO)
            const localVarPath = `/api/v1/widget-keys/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(widgetKeyCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revoke a widget key (soft delete — sets ``is_active=False``).  The row is kept and still listed so it can be reactivated via PATCH. Requires \'widget_key:write\' permission.
         * @summary Delete Widget Key
         * @param {string} widgetKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWidgetKeyApiV1WidgetKeysWidgetKeyIdDelete: async (widgetKeyId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'widgetKeyId' is not null or undefined
            assertParamExists('deleteWidgetKeyApiV1WidgetKeysWidgetKeyIdDelete', 'widgetKeyId', widgetKeyId)
            const localVarPath = `/api/v1/widget-keys/{widget_key_id}`
                .replace(`{${"widget_key_id"}}`, encodeURIComponent(String(widgetKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revoke a widget key (soft delete — sets ``is_active=False``).  The row is kept and still listed so it can be reactivated via PATCH. Requires \'widget_key:write\' permission.
         * @summary Delete Widget Key
         * @param {string} widgetKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWidgetKeyApiV1WidgetKeysWidgetKeyIdDelete_2: async (widgetKeyId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'widgetKeyId' is not null or undefined
            assertParamExists('deleteWidgetKeyApiV1WidgetKeysWidgetKeyIdDelete_2', 'widgetKeyId', widgetKeyId)
            const localVarPath = `/api/v1/widget-keys/{widget_key_id}`
                .replace(`{${"widget_key_id"}}`, encodeURIComponent(String(widgetKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove the widget\'s logo image.  Requires \'widget_key:write\' permission.
         * @summary Delete Widget Key Logo
         * @param {string} widgetKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoDelete: async (widgetKeyId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'widgetKeyId' is not null or undefined
            assertParamExists('deleteWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoDelete', 'widgetKeyId', widgetKeyId)
            const localVarPath = `/api/v1/widget-keys/{widget_key_id}/logo`
                .replace(`{${"widget_key_id"}}`, encodeURIComponent(String(widgetKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove the widget\'s logo image.  Requires \'widget_key:write\' permission.
         * @summary Delete Widget Key Logo
         * @param {string} widgetKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoDelete_3: async (widgetKeyId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'widgetKeyId' is not null or undefined
            assertParamExists('deleteWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoDelete_3', 'widgetKeyId', widgetKeyId)
            const localVarPath = `/api/v1/widget-keys/{widget_key_id}/logo`
                .replace(`{${"widget_key_id"}}`, encodeURIComponent(String(widgetKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific widget key by ID (full key value included).  Requires \'widget_key:view\' permission.
         * @summary Get Widget Key
         * @param {string} widgetKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetKeyApiV1WidgetKeysWidgetKeyIdGet: async (widgetKeyId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'widgetKeyId' is not null or undefined
            assertParamExists('getWidgetKeyApiV1WidgetKeysWidgetKeyIdGet', 'widgetKeyId', widgetKeyId)
            const localVarPath = `/api/v1/widget-keys/{widget_key_id}`
                .replace(`{${"widget_key_id"}}`, encodeURIComponent(String(widgetKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific widget key by ID (full key value included).  Requires \'widget_key:view\' permission.
         * @summary Get Widget Key
         * @param {string} widgetKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetKeyApiV1WidgetKeysWidgetKeyIdGet_4: async (widgetKeyId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'widgetKeyId' is not null or undefined
            assertParamExists('getWidgetKeyApiV1WidgetKeysWidgetKeyIdGet_4', 'widgetKeyId', widgetKeyId)
            const localVarPath = `/api/v1/widget-keys/{widget_key_id}`
                .replace(`{${"widget_key_id"}}`, encodeURIComponent(String(widgetKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all widget keys for the organization, including revoked (inactive) ones.  Requires \'widget_key:view\' permission.
         * @summary List Widget Keys
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWidgetKeysApiV1WidgetKeysGet: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/widget-keys/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all widget keys for the organization, including revoked (inactive) ones.  Requires \'widget_key:view\' permission.
         * @summary List Widget Keys
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWidgetKeysApiV1WidgetKeysGet_5: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/widget-keys/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload (or replace) the widget\'s logo image.  PNG format and size limits are enforced by the service. The returned DTO includes the resulting ``logo_url``.  Requires \'widget_key:write\' permission.
         * @summary Set Widget Key Logo
         * @param {string} widgetKeyId 
         * @param {string} file 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoPut: async (widgetKeyId: string, file: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'widgetKeyId' is not null or undefined
            assertParamExists('setWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoPut', 'widgetKeyId', widgetKeyId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('setWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoPut', 'file', file)
            const localVarPath = `/api/v1/widget-keys/{widget_key_id}/logo`
                .replace(`{${"widget_key_id"}}`, encodeURIComponent(String(widgetKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload (or replace) the widget\'s logo image.  PNG format and size limits are enforced by the service. The returned DTO includes the resulting ``logo_url``.  Requires \'widget_key:write\' permission.
         * @summary Set Widget Key Logo
         * @param {string} widgetKeyId 
         * @param {string} file 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoPut_6: async (widgetKeyId: string, file: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'widgetKeyId' is not null or undefined
            assertParamExists('setWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoPut_6', 'widgetKeyId', widgetKeyId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('setWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoPut_6', 'file', file)
            const localVarPath = `/api/v1/widget-keys/{widget_key_id}/logo`
                .replace(`{${"widget_key_id"}}`, encodeURIComponent(String(widgetKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a widget key\'s label, allowed origins, active status, or agent.  The agent can be re-pointed to another agent in the same organization; the swap takes effect immediately for every embed using this key. The key value itself is immutable — create a new key instead. A ``PATCH is_active=true`` reactivates a revoked key.  Requires \'widget_key:write\' permission.
         * @summary Update Widget Key
         * @param {string} widgetKeyId 
         * @param {WidgetKeyUpdateDTO} widgetKeyUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWidgetKeyApiV1WidgetKeysWidgetKeyIdPatch: async (widgetKeyId: string, widgetKeyUpdateDTO: WidgetKeyUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'widgetKeyId' is not null or undefined
            assertParamExists('updateWidgetKeyApiV1WidgetKeysWidgetKeyIdPatch', 'widgetKeyId', widgetKeyId)
            // verify required parameter 'widgetKeyUpdateDTO' is not null or undefined
            assertParamExists('updateWidgetKeyApiV1WidgetKeysWidgetKeyIdPatch', 'widgetKeyUpdateDTO', widgetKeyUpdateDTO)
            const localVarPath = `/api/v1/widget-keys/{widget_key_id}`
                .replace(`{${"widget_key_id"}}`, encodeURIComponent(String(widgetKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(widgetKeyUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a widget key\'s label, allowed origins, active status, or agent.  The agent can be re-pointed to another agent in the same organization; the swap takes effect immediately for every embed using this key. The key value itself is immutable — create a new key instead. A ``PATCH is_active=true`` reactivates a revoked key.  Requires \'widget_key:write\' permission.
         * @summary Update Widget Key
         * @param {string} widgetKeyId 
         * @param {WidgetKeyUpdateDTO} widgetKeyUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWidgetKeyApiV1WidgetKeysWidgetKeyIdPatch_7: async (widgetKeyId: string, widgetKeyUpdateDTO: WidgetKeyUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'widgetKeyId' is not null or undefined
            assertParamExists('updateWidgetKeyApiV1WidgetKeysWidgetKeyIdPatch_7', 'widgetKeyId', widgetKeyId)
            // verify required parameter 'widgetKeyUpdateDTO' is not null or undefined
            assertParamExists('updateWidgetKeyApiV1WidgetKeysWidgetKeyIdPatch_7', 'widgetKeyUpdateDTO', widgetKeyUpdateDTO)
            const localVarPath = `/api/v1/widget-keys/{widget_key_id}`
                .replace(`{${"widget_key_id"}}`, encodeURIComponent(String(widgetKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(widgetKeyUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WidgetKeysApi - functional programming interface
 * @export
 */
export const WidgetKeysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WidgetKeysApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a widget key for an agent in the current organization.  The returned ``key`` is a PUBLIC identifier shipped in client-side JS; it can be re-read at any time. An empty ``allowed_origins`` is accepted but leaves the key inert from every origin until origins are configured.  Requires \'widget_key:write\' permission.
         * @summary Create Widget Key
         * @param {WidgetKeyCreateDTO} widgetKeyCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWidgetKeyApiV1WidgetKeysPost(widgetKeyCreateDTO: WidgetKeyCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WidgetKeyResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWidgetKeyApiV1WidgetKeysPost(widgetKeyCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetKeysApi.createWidgetKeyApiV1WidgetKeysPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a widget key for an agent in the current organization.  The returned ``key`` is a PUBLIC identifier shipped in client-side JS; it can be re-read at any time. An empty ``allowed_origins`` is accepted but leaves the key inert from every origin until origins are configured.  Requires \'widget_key:write\' permission.
         * @summary Create Widget Key
         * @param {WidgetKeyCreateDTO} widgetKeyCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWidgetKeyApiV1WidgetKeysPost_1(widgetKeyCreateDTO: WidgetKeyCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WidgetKeyResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWidgetKeyApiV1WidgetKeysPost_1(widgetKeyCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetKeysApi.createWidgetKeyApiV1WidgetKeysPost_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Revoke a widget key (soft delete — sets ``is_active=False``).  The row is kept and still listed so it can be reactivated via PATCH. Requires \'widget_key:write\' permission.
         * @summary Delete Widget Key
         * @param {string} widgetKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWidgetKeyApiV1WidgetKeysWidgetKeyIdDelete(widgetKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWidgetKeyApiV1WidgetKeysWidgetKeyIdDelete(widgetKeyId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetKeysApi.deleteWidgetKeyApiV1WidgetKeysWidgetKeyIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Revoke a widget key (soft delete — sets ``is_active=False``).  The row is kept and still listed so it can be reactivated via PATCH. Requires \'widget_key:write\' permission.
         * @summary Delete Widget Key
         * @param {string} widgetKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWidgetKeyApiV1WidgetKeysWidgetKeyIdDelete_2(widgetKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWidgetKeyApiV1WidgetKeysWidgetKeyIdDelete_2(widgetKeyId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetKeysApi.deleteWidgetKeyApiV1WidgetKeysWidgetKeyIdDelete_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove the widget\'s logo image.  Requires \'widget_key:write\' permission.
         * @summary Delete Widget Key Logo
         * @param {string} widgetKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoDelete(widgetKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoDelete(widgetKeyId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetKeysApi.deleteWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove the widget\'s logo image.  Requires \'widget_key:write\' permission.
         * @summary Delete Widget Key Logo
         * @param {string} widgetKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoDelete_3(widgetKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoDelete_3(widgetKeyId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetKeysApi.deleteWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoDelete_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific widget key by ID (full key value included).  Requires \'widget_key:view\' permission.
         * @summary Get Widget Key
         * @param {string} widgetKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWidgetKeyApiV1WidgetKeysWidgetKeyIdGet(widgetKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WidgetKeyResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWidgetKeyApiV1WidgetKeysWidgetKeyIdGet(widgetKeyId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetKeysApi.getWidgetKeyApiV1WidgetKeysWidgetKeyIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific widget key by ID (full key value included).  Requires \'widget_key:view\' permission.
         * @summary Get Widget Key
         * @param {string} widgetKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWidgetKeyApiV1WidgetKeysWidgetKeyIdGet_4(widgetKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WidgetKeyResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWidgetKeyApiV1WidgetKeysWidgetKeyIdGet_4(widgetKeyId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetKeysApi.getWidgetKeyApiV1WidgetKeysWidgetKeyIdGet_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all widget keys for the organization, including revoked (inactive) ones.  Requires \'widget_key:view\' permission.
         * @summary List Widget Keys
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWidgetKeysApiV1WidgetKeysGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWidgetKeyResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWidgetKeysApiV1WidgetKeysGet(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetKeysApi.listWidgetKeysApiV1WidgetKeysGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all widget keys for the organization, including revoked (inactive) ones.  Requires \'widget_key:view\' permission.
         * @summary List Widget Keys
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWidgetKeysApiV1WidgetKeysGet_5(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWidgetKeyResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWidgetKeysApiV1WidgetKeysGet_5(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetKeysApi.listWidgetKeysApiV1WidgetKeysGet_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload (or replace) the widget\'s logo image.  PNG format and size limits are enforced by the service. The returned DTO includes the resulting ``logo_url``.  Requires \'widget_key:write\' permission.
         * @summary Set Widget Key Logo
         * @param {string} widgetKeyId 
         * @param {string} file 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoPut(widgetKeyId: string, file: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WidgetKeyResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoPut(widgetKeyId, file, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetKeysApi.setWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload (or replace) the widget\'s logo image.  PNG format and size limits are enforced by the service. The returned DTO includes the resulting ``logo_url``.  Requires \'widget_key:write\' permission.
         * @summary Set Widget Key Logo
         * @param {string} widgetKeyId 
         * @param {string} file 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoPut_6(widgetKeyId: string, file: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WidgetKeyResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoPut_6(widgetKeyId, file, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetKeysApi.setWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoPut_6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a widget key\'s label, allowed origins, active status, or agent.  The agent can be re-pointed to another agent in the same organization; the swap takes effect immediately for every embed using this key. The key value itself is immutable — create a new key instead. A ``PATCH is_active=true`` reactivates a revoked key.  Requires \'widget_key:write\' permission.
         * @summary Update Widget Key
         * @param {string} widgetKeyId 
         * @param {WidgetKeyUpdateDTO} widgetKeyUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWidgetKeyApiV1WidgetKeysWidgetKeyIdPatch(widgetKeyId: string, widgetKeyUpdateDTO: WidgetKeyUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WidgetKeyResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWidgetKeyApiV1WidgetKeysWidgetKeyIdPatch(widgetKeyId, widgetKeyUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetKeysApi.updateWidgetKeyApiV1WidgetKeysWidgetKeyIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a widget key\'s label, allowed origins, active status, or agent.  The agent can be re-pointed to another agent in the same organization; the swap takes effect immediately for every embed using this key. The key value itself is immutable — create a new key instead. A ``PATCH is_active=true`` reactivates a revoked key.  Requires \'widget_key:write\' permission.
         * @summary Update Widget Key
         * @param {string} widgetKeyId 
         * @param {WidgetKeyUpdateDTO} widgetKeyUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWidgetKeyApiV1WidgetKeysWidgetKeyIdPatch_7(widgetKeyId: string, widgetKeyUpdateDTO: WidgetKeyUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WidgetKeyResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWidgetKeyApiV1WidgetKeysWidgetKeyIdPatch_7(widgetKeyId, widgetKeyUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetKeysApi.updateWidgetKeyApiV1WidgetKeysWidgetKeyIdPatch_7']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WidgetKeysApi - factory interface
 * @export
 */
export const WidgetKeysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WidgetKeysApiFp(configuration)
    return {
        /**
         * Create a widget key for an agent in the current organization.  The returned ``key`` is a PUBLIC identifier shipped in client-side JS; it can be re-read at any time. An empty ``allowed_origins`` is accepted but leaves the key inert from every origin until origins are configured.  Requires \'widget_key:write\' permission.
         * @summary Create Widget Key
         * @param {WidgetKeyCreateDTO} widgetKeyCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWidgetKeyApiV1WidgetKeysPost(widgetKeyCreateDTO: WidgetKeyCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<WidgetKeyResponseDTO> {
            return localVarFp.createWidgetKeyApiV1WidgetKeysPost(widgetKeyCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a widget key for an agent in the current organization.  The returned ``key`` is a PUBLIC identifier shipped in client-side JS; it can be re-read at any time. An empty ``allowed_origins`` is accepted but leaves the key inert from every origin until origins are configured.  Requires \'widget_key:write\' permission.
         * @summary Create Widget Key
         * @param {WidgetKeyCreateDTO} widgetKeyCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWidgetKeyApiV1WidgetKeysPost_1(widgetKeyCreateDTO: WidgetKeyCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<WidgetKeyResponseDTO> {
            return localVarFp.createWidgetKeyApiV1WidgetKeysPost_1(widgetKeyCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Revoke a widget key (soft delete — sets ``is_active=False``).  The row is kept and still listed so it can be reactivated via PATCH. Requires \'widget_key:write\' permission.
         * @summary Delete Widget Key
         * @param {string} widgetKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWidgetKeyApiV1WidgetKeysWidgetKeyIdDelete(widgetKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteWidgetKeyApiV1WidgetKeysWidgetKeyIdDelete(widgetKeyId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Revoke a widget key (soft delete — sets ``is_active=False``).  The row is kept and still listed so it can be reactivated via PATCH. Requires \'widget_key:write\' permission.
         * @summary Delete Widget Key
         * @param {string} widgetKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWidgetKeyApiV1WidgetKeysWidgetKeyIdDelete_2(widgetKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteWidgetKeyApiV1WidgetKeysWidgetKeyIdDelete_2(widgetKeyId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove the widget\'s logo image.  Requires \'widget_key:write\' permission.
         * @summary Delete Widget Key Logo
         * @param {string} widgetKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoDelete(widgetKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoDelete(widgetKeyId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove the widget\'s logo image.  Requires \'widget_key:write\' permission.
         * @summary Delete Widget Key Logo
         * @param {string} widgetKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoDelete_3(widgetKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoDelete_3(widgetKeyId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific widget key by ID (full key value included).  Requires \'widget_key:view\' permission.
         * @summary Get Widget Key
         * @param {string} widgetKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetKeyApiV1WidgetKeysWidgetKeyIdGet(widgetKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<WidgetKeyResponseDTO> {
            return localVarFp.getWidgetKeyApiV1WidgetKeysWidgetKeyIdGet(widgetKeyId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific widget key by ID (full key value included).  Requires \'widget_key:view\' permission.
         * @summary Get Widget Key
         * @param {string} widgetKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetKeyApiV1WidgetKeysWidgetKeyIdGet_4(widgetKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<WidgetKeyResponseDTO> {
            return localVarFp.getWidgetKeyApiV1WidgetKeysWidgetKeyIdGet_4(widgetKeyId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all widget keys for the organization, including revoked (inactive) ones.  Requires \'widget_key:view\' permission.
         * @summary List Widget Keys
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWidgetKeysApiV1WidgetKeysGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageWidgetKeyResponseDTO> {
            return localVarFp.listWidgetKeysApiV1WidgetKeysGet(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all widget keys for the organization, including revoked (inactive) ones.  Requires \'widget_key:view\' permission.
         * @summary List Widget Keys
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWidgetKeysApiV1WidgetKeysGet_5(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageWidgetKeyResponseDTO> {
            return localVarFp.listWidgetKeysApiV1WidgetKeysGet_5(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload (or replace) the widget\'s logo image.  PNG format and size limits are enforced by the service. The returned DTO includes the resulting ``logo_url``.  Requires \'widget_key:write\' permission.
         * @summary Set Widget Key Logo
         * @param {string} widgetKeyId 
         * @param {string} file 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoPut(widgetKeyId: string, file: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<WidgetKeyResponseDTO> {
            return localVarFp.setWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoPut(widgetKeyId, file, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload (or replace) the widget\'s logo image.  PNG format and size limits are enforced by the service. The returned DTO includes the resulting ``logo_url``.  Requires \'widget_key:write\' permission.
         * @summary Set Widget Key Logo
         * @param {string} widgetKeyId 
         * @param {string} file 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoPut_6(widgetKeyId: string, file: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<WidgetKeyResponseDTO> {
            return localVarFp.setWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoPut_6(widgetKeyId, file, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a widget key\'s label, allowed origins, active status, or agent.  The agent can be re-pointed to another agent in the same organization; the swap takes effect immediately for every embed using this key. The key value itself is immutable — create a new key instead. A ``PATCH is_active=true`` reactivates a revoked key.  Requires \'widget_key:write\' permission.
         * @summary Update Widget Key
         * @param {string} widgetKeyId 
         * @param {WidgetKeyUpdateDTO} widgetKeyUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWidgetKeyApiV1WidgetKeysWidgetKeyIdPatch(widgetKeyId: string, widgetKeyUpdateDTO: WidgetKeyUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<WidgetKeyResponseDTO> {
            return localVarFp.updateWidgetKeyApiV1WidgetKeysWidgetKeyIdPatch(widgetKeyId, widgetKeyUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a widget key\'s label, allowed origins, active status, or agent.  The agent can be re-pointed to another agent in the same organization; the swap takes effect immediately for every embed using this key. The key value itself is immutable — create a new key instead. A ``PATCH is_active=true`` reactivates a revoked key.  Requires \'widget_key:write\' permission.
         * @summary Update Widget Key
         * @param {string} widgetKeyId 
         * @param {WidgetKeyUpdateDTO} widgetKeyUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWidgetKeyApiV1WidgetKeysWidgetKeyIdPatch_7(widgetKeyId: string, widgetKeyUpdateDTO: WidgetKeyUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<WidgetKeyResponseDTO> {
            return localVarFp.updateWidgetKeyApiV1WidgetKeysWidgetKeyIdPatch_7(widgetKeyId, widgetKeyUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WidgetKeysApi - object-oriented interface
 * @export
 * @class WidgetKeysApi
 * @extends {BaseAPI}
 */
export class WidgetKeysApi extends BaseAPI {
    /**
     * Create a widget key for an agent in the current organization.  The returned ``key`` is a PUBLIC identifier shipped in client-side JS; it can be re-read at any time. An empty ``allowed_origins`` is accepted but leaves the key inert from every origin until origins are configured.  Requires \'widget_key:write\' permission.
     * @summary Create Widget Key
     * @param {WidgetKeyCreateDTO} widgetKeyCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetKeysApi
     */
    public createWidgetKeyApiV1WidgetKeysPost(widgetKeyCreateDTO: WidgetKeyCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return WidgetKeysApiFp(this.configuration).createWidgetKeyApiV1WidgetKeysPost(widgetKeyCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a widget key for an agent in the current organization.  The returned ``key`` is a PUBLIC identifier shipped in client-side JS; it can be re-read at any time. An empty ``allowed_origins`` is accepted but leaves the key inert from every origin until origins are configured.  Requires \'widget_key:write\' permission.
     * @summary Create Widget Key
     * @param {WidgetKeyCreateDTO} widgetKeyCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetKeysApi
     */
    public createWidgetKeyApiV1WidgetKeysPost_1(widgetKeyCreateDTO: WidgetKeyCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return WidgetKeysApiFp(this.configuration).createWidgetKeyApiV1WidgetKeysPost_1(widgetKeyCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revoke a widget key (soft delete — sets ``is_active=False``).  The row is kept and still listed so it can be reactivated via PATCH. Requires \'widget_key:write\' permission.
     * @summary Delete Widget Key
     * @param {string} widgetKeyId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetKeysApi
     */
    public deleteWidgetKeyApiV1WidgetKeysWidgetKeyIdDelete(widgetKeyId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return WidgetKeysApiFp(this.configuration).deleteWidgetKeyApiV1WidgetKeysWidgetKeyIdDelete(widgetKeyId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revoke a widget key (soft delete — sets ``is_active=False``).  The row is kept and still listed so it can be reactivated via PATCH. Requires \'widget_key:write\' permission.
     * @summary Delete Widget Key
     * @param {string} widgetKeyId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetKeysApi
     */
    public deleteWidgetKeyApiV1WidgetKeysWidgetKeyIdDelete_2(widgetKeyId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return WidgetKeysApiFp(this.configuration).deleteWidgetKeyApiV1WidgetKeysWidgetKeyIdDelete_2(widgetKeyId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove the widget\'s logo image.  Requires \'widget_key:write\' permission.
     * @summary Delete Widget Key Logo
     * @param {string} widgetKeyId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetKeysApi
     */
    public deleteWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoDelete(widgetKeyId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return WidgetKeysApiFp(this.configuration).deleteWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoDelete(widgetKeyId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove the widget\'s logo image.  Requires \'widget_key:write\' permission.
     * @summary Delete Widget Key Logo
     * @param {string} widgetKeyId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetKeysApi
     */
    public deleteWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoDelete_3(widgetKeyId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return WidgetKeysApiFp(this.configuration).deleteWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoDelete_3(widgetKeyId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific widget key by ID (full key value included).  Requires \'widget_key:view\' permission.
     * @summary Get Widget Key
     * @param {string} widgetKeyId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetKeysApi
     */
    public getWidgetKeyApiV1WidgetKeysWidgetKeyIdGet(widgetKeyId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return WidgetKeysApiFp(this.configuration).getWidgetKeyApiV1WidgetKeysWidgetKeyIdGet(widgetKeyId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific widget key by ID (full key value included).  Requires \'widget_key:view\' permission.
     * @summary Get Widget Key
     * @param {string} widgetKeyId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetKeysApi
     */
    public getWidgetKeyApiV1WidgetKeysWidgetKeyIdGet_4(widgetKeyId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return WidgetKeysApiFp(this.configuration).getWidgetKeyApiV1WidgetKeysWidgetKeyIdGet_4(widgetKeyId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all widget keys for the organization, including revoked (inactive) ones.  Requires \'widget_key:view\' permission.
     * @summary List Widget Keys
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetKeysApi
     */
    public listWidgetKeysApiV1WidgetKeysGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return WidgetKeysApiFp(this.configuration).listWidgetKeysApiV1WidgetKeysGet(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all widget keys for the organization, including revoked (inactive) ones.  Requires \'widget_key:view\' permission.
     * @summary List Widget Keys
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetKeysApi
     */
    public listWidgetKeysApiV1WidgetKeysGet_5(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return WidgetKeysApiFp(this.configuration).listWidgetKeysApiV1WidgetKeysGet_5(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload (or replace) the widget\'s logo image.  PNG format and size limits are enforced by the service. The returned DTO includes the resulting ``logo_url``.  Requires \'widget_key:write\' permission.
     * @summary Set Widget Key Logo
     * @param {string} widgetKeyId 
     * @param {string} file 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetKeysApi
     */
    public setWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoPut(widgetKeyId: string, file: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return WidgetKeysApiFp(this.configuration).setWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoPut(widgetKeyId, file, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload (or replace) the widget\'s logo image.  PNG format and size limits are enforced by the service. The returned DTO includes the resulting ``logo_url``.  Requires \'widget_key:write\' permission.
     * @summary Set Widget Key Logo
     * @param {string} widgetKeyId 
     * @param {string} file 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetKeysApi
     */
    public setWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoPut_6(widgetKeyId: string, file: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return WidgetKeysApiFp(this.configuration).setWidgetKeyLogoApiV1WidgetKeysWidgetKeyIdLogoPut_6(widgetKeyId, file, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a widget key\'s label, allowed origins, active status, or agent.  The agent can be re-pointed to another agent in the same organization; the swap takes effect immediately for every embed using this key. The key value itself is immutable — create a new key instead. A ``PATCH is_active=true`` reactivates a revoked key.  Requires \'widget_key:write\' permission.
     * @summary Update Widget Key
     * @param {string} widgetKeyId 
     * @param {WidgetKeyUpdateDTO} widgetKeyUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetKeysApi
     */
    public updateWidgetKeyApiV1WidgetKeysWidgetKeyIdPatch(widgetKeyId: string, widgetKeyUpdateDTO: WidgetKeyUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return WidgetKeysApiFp(this.configuration).updateWidgetKeyApiV1WidgetKeysWidgetKeyIdPatch(widgetKeyId, widgetKeyUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a widget key\'s label, allowed origins, active status, or agent.  The agent can be re-pointed to another agent in the same organization; the swap takes effect immediately for every embed using this key. The key value itself is immutable — create a new key instead. A ``PATCH is_active=true`` reactivates a revoked key.  Requires \'widget_key:write\' permission.
     * @summary Update Widget Key
     * @param {string} widgetKeyId 
     * @param {WidgetKeyUpdateDTO} widgetKeyUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetKeysApi
     */
    public updateWidgetKeyApiV1WidgetKeysWidgetKeyIdPatch_7(widgetKeyId: string, widgetKeyUpdateDTO: WidgetKeyUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return WidgetKeysApiFp(this.configuration).updateWidgetKeyApiV1WidgetKeysWidgetKeyIdPatch_7(widgetKeyId, widgetKeyUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

